import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Delivery',
  [ORDER_METHODS.pickup]: 'Pickup',
  [ORDER_METHODS.room_service]: 'Room service',
};
